import styled from 'styled-components'
import { LoadingOutlined, CheckCircleOutlined } from '@ant-design/icons'
import { SPACING, COMMON, TYPOGRAPHY } from '../../styles/theme'

/**
 * Styled components for TrelloCallbackPage
 * Replaces all inline styles with reusable styled components
 */

// Processing state container - flex column centered with full viewport height
export const ProcessingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: ${COMMON.fullViewportHeight};
  gap: ${SPACING.lg};
`

// Loading icon with custom size
export const LoadingIcon = styled(LoadingOutlined)`
  font-size: ${TYPOGRAPHY.h1.fontSize};
`

// Result container - flex centered with full viewport height and padding
export const ResultContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: ${COMMON.fullViewportHeight};
  padding: ${SPACING.xl};
`

// Success check icon with custom color
export const SuccessIcon = styled(CheckCircleOutlined)`
  color: #52c41a;
`
